import { endOfMonth, format, isBefore, parse, parseISO } from 'date-fns';

// date-fns formats
export const FORMAT_WEEKDAY_DATE_YEAR = 'iii, dd MMM, yyyy'; // Wed, 31 Aug, 2022
export const FORMAT_QT_DATE = 'yyyy-MM-dd'; // 2022-08-31
export const FORMAT_FULL_DATE_MINI = 'dd MMM yyyy'; // 31 Aug 2022
export const FORMAT_WEEKDAY_DATE_MINI = 'iii d LLL'; // Wed 31 Aug
export const FORMAT_TIME_ONLY = 'h:mm b'; // 8:56 AM
export const FORMAT_D = 'd'; // 31

// Mobiscroll formats
// https://docs.mobiscroll.com/react/datepicker#localization-dateFormat
export const FORMAT_WEEKDAY_DATE_MOBI = 'D MMM'; // Wed 31 Aug
export const FORMAT_FULL_WEEKDAY_DATE_MOBI = 'EEEE, MMM d'; // Wednesday, Aug 31. For testing only, do NOT use this format in UI.
export const FORMAT_WEEKDAY_DATE_YEAR_MOBI = 'DDD, MMM DD, YYYY'; // Wed, May 11, 2022

export const FIVE_MINUTES_IN_MILLISECONDS = 300000;

// Date format (date-fns) Example: Friday, 25th March 2022
export const formatDate = (date, dateFormat = FORMAT_WEEKDAY_DATE_YEAR) =>
  format(parseISO(date), dateFormat);

export const parseTime = (timeString) => {
  // Pretend to be UTC to display the time with same timezone from the time string
  // Examples: 2000-01-01T11:00:00.000+10:30, 2000-06-01T11:00:00.000Z
  timeString = timeString.substr(0, 23).concat('Z');

  return new Date(timeString).toLocaleTimeString('en-US', {
    timeZone: 'UTC',
    hour12: true,
    hour: 'numeric',
    minute: 'numeric',
  });
};

export const combineDates = (date, time) =>
  new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    time.getUTCHours(),
    time.getUTCMinutes(),
    time.getUTCSeconds()
  );

// TODO: We should modify QuickTravel to return the dates in the format it also
// expects to receive it in, i.e. "2022-05-01" and NOT 01-05-2022"
// https://travellink-technology.atlassian.net/browse/OS-1363
export const reverseQtDate = (date) => date?.split('-').reverse().join('-');

// Return if a card is expired based on card expiry date
export const isCardExpired = (expiryDate) => {
  const parsedExpiryDate = endOfMonth(parse(expiryDate, 'MM/yyyy', new Date()));
  const isExpired = isBefore(parsedExpiryDate, new Date());
  return isExpired;
};

export const timestamp = (time) => new Date(time).getTime();
